/**
 * @generated SignedSource<<4c911de005ad2af605b5045e0f017e83>>
 * @relayHash c4bb3401c5656a22c293347909b15f28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6139d1548ad2a1fc98c7d37c8cb72a45dc67b0a9291f97617cae811a5fe79e5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b6139d1548ad2a1fc98c7d37c8cb72a45dc67b0a9291f97617cae811a5fe79e5",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
